<template>
    <div class="skip-links">
        <BaseButton
            class="skip-links__link"
            element="a"
            href="#main-content-landmark"
            label="Spring naar hoofdinhoud"
        />
        <BaseButton
            class="skip-links__link"
            element="a"
            href="#footer-landmark"
            label="Spring naar footer"
        />
    </div>
</template>

<style lang="less" src="./SkipLinks.less" />
